import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PointCardCodeInStoreTemplate } from 'components/Templates'

const PointCardCodeInStore: FC = () => {
  return (
    <Layout title={'ポイント付与QRコード'}>
      <PointCardCodeInStoreTemplate />
    </Layout>
  )
}

export default PointCardCodeInStore
